import React, {useEffect, useState} from 'react'
import AppendHead from 'react-append-head'
import {useDispatch} from "react-redux"

import "react-toastify/dist/ReactToastify.css"
import socketIoClient from 'socket.io-client'

import {urlServer} from "./api"

import Views from './Views'

function App() {
  const dispatch = useDispatch()

  const [socketState, setSocket] = useState(null)

  useEffect(() => {
    var socket = socketIoClient(urlServer, {
      reconnectionDelay: 1000,
      reconnection:true,
      reconnectionAttempts: 10,
      transports: ['websocket'],
      agent: false,
      upgrade: false,
    })

    // TEMP code before reconnecting to Heroku:
    dispatch({
      type: "HIDE_LOADER",
    })

    try {
      socket.on('connect', () => {
        // dispatch({
        //   type: "APP_CONNECTED",
        // })
      })
    } catch (e) {
      console.log("ERROR CONNECTING TO SOCKET")
      console.log(e)
    }
    socket.on('connect_error', (err) => {
      console.log(`Socket connect_erorr due to ${err.message}`)
    })

    socket.on('serverConnect', (dataServer) => {
      console.log(dataServer)
      dispatch({
        type: "APP_CONNECTED",
        dataServer,
      })
    })


    setSocket(socket)

    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [])

  return (
    <div className="App">
      <AppendHead>
        <style>
          {"@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap');"}"
        </style>
      </AppendHead>
      <Views socket={socketState}/>
    </div>
  );
}

export default App
